import { createBrowserRouter } from "react-router-dom";

import Login from "pages/Login";
import AccountShow from "pages/accounts/show";
import AccountList from "pages/accounts/list";
import AccountCreate from "pages/accounts/create";
import AccountUpdate from "pages/accounts/update";
import CapitalList from "pages/capitals/list";
import FigureList from "pages/figures/list";
import FigureCreate from "pages/figures/create";
import TransactionList from "pages/transactions/list";
import TransactionCreate from "pages/transactions/create";
import TransactionShow from "pages/transactions/show";
import NotFound from "pages/NotFound";
import TransactionUpdate from "pages/transactions/update";
import CurrencyBalance from "pages/reports/currency-balance";
import CapitalEntryList from "pages/capital-entries/list";
import CapitalEntryCreate from "pages/capital-entries/create";
import CapitalCreate from "pages/capitals/create";

const router = createBrowserRouter([
  {
    index: true,
    element: <TransactionList />
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: 'accounts',
    element: <AccountList />
  },
  {
    path: 'accounts/:id',
    element: <AccountShow />
  },
  {
    path: 'accounts/create',
    element: <AccountCreate />
  },
  {
    path: 'accounts/:id/update',
    element: <AccountUpdate />
  },
  {
    path: 'capitals',
    element: <CapitalList />
  },
  {
    path: 'capitals/create',
    element: <CapitalCreate />
  },
  {
    path: 'capitals/:id/entries',
    element: <CapitalEntryList />
  },
  {
    path: 'capitals/:id/entries/create',
    element: <CapitalEntryCreate />
  },
  {
    path: 'figures',
    element: <FigureList />
  },
  {
    path: 'figures/create',
    element: <FigureCreate />
  },
  {
    path: 'figures/create',
    element: <FigureCreate />
  },
  {
    path: 'transactions',
    element: <TransactionList />
  },
  {
    path: 'transactions/create',
    element: <TransactionCreate />
  },
  {
    path: 'transactions/:id',
    element: <TransactionShow />
  },
  {
    path: 'transactions/:id/update',
    element: <TransactionUpdate />
  },
  {
    path: 'reports/currencies-balance',
    element: <CurrencyBalance />
  },
  {
    path: '*',
    element: <NotFound />
  },
]);

export default router;
